/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
// External Imports
import moment from 'moment';
// Internal Imports
import LogAdministered from 'linced-app/enums/medical/log-administered';
import LogType from 'linced-app/enums/medical/log-type';
import Reason from 'linced-app/enums/medical/reason';
import { action } from '@ember/object';

export default class BatchDelete extends Component {
  // Services
  @service
  countdownButton;

  @service
  session;

  @service
  store;

  @service
  toaster;

  Reason = Reason;

  batch = null;

  @tracked
  deleteInProgress = false;

  @tracked
  dialogOpen = false;

  @tracked
  reason = null;

  @action
  setReason(value) {
    this.reason = value;
  }

  @action
  openDialog() {
    this.dialogOpen = true;
    this.reason = null;
    this.countdownButton.initialise(3);
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
    this.countdownButton.cleanup();
  }

  @action
  async delete() {
    this.store
      .createRecord('medical/log', {
        schoolId: this.get('session.school'),
        logType: LogType.UPDATE,
        medication: await this.batch.medication,
        batch: this.batch,
        displayDate: moment().unix(),
        administeredBy: LogAdministered.STAFF,
        administeredByPerson: this.get('session.person'),
        administrationDetails:
          this.get('batch.quantity') +
          ' ' +
          this.get('batch.medication.unitString'),
        reason: this.reason.value,
      })
      .save()
      .then(() => {
        this.batch
          .destroyRecord()
          .then(() => {
            this.toaster.success('Batch deleted successfully!');
          })
          .catch(() => {
            this.toaster.error('Batch delete failed!');
          });
      })
      .catch(() => {
        this.toaster.error('Log save failed!');
      })
      .finally(() => {
        // A successful destroyRecord() removes the batch from the store,
        // which immediately tears down this row (and this component) via
        // the list's {{#each}}. This callback can still fire afterward, so
        // guard against setting properties on an already-destroyed
        // component.
        if (this.isDestroying || this.isDestroyed) {
          return;
        }
        this.dialogOpen = false;
        this.deleteInProgress = false;
      });
  }
}
